(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', './BlobLocation', './PreviewData'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./BlobLocation'), require('./PreviewData'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.Transaction = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.BlobLocation, root.SmartCsV2Sdk.PreviewData);
  }
}(this, function(ApiClient, BlobLocation, PreviewData) {
  'use strict';

  /**
   * The Transaction model module.
   * @module model/Transaction
   * @version 2.0.624
   */

  /**
   * Constructs a new <code>Transaction</code>.
   * @alias module:model/Transaction
   * @class
   */
  var exports = function() {





















  };

  /**
   * Constructs a <code>Transaction</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Transaction} obj Optional instance to populate.
   * @return {module:model/Transaction} The populated <code>Transaction</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) { 
      obj = obj || new exports();

      if (data.hasOwnProperty('contentId')) {
        obj['contentId'] = ApiClient.convertToType(data['contentId'], 'String');
      }
      if (data.hasOwnProperty('contentIdsToPrune')) {
        obj['contentIdsToPrune'] = ApiClient.convertToType(data['contentIdsToPrune'], ['String']);
      }
      if (data.hasOwnProperty('created')) {
        obj['created'] = ApiClient.convertToType(data['created'], 'Integer');
      }
      if (data.hasOwnProperty('creatorId')) {
        obj['creatorId'] = ApiClient.convertToType(data['creatorId'], 'String');
      }
      if (data.hasOwnProperty('customData')) {
        obj['customData'] = ApiClient.convertToType(data['customData'], Object);
      }
      if (data.hasOwnProperty('expired')) {
        obj['expired'] = ApiClient.convertToType(data['expired'], 'Boolean');
      }
      if (data.hasOwnProperty('expiry')) {
        obj['expiry'] = ApiClient.convertToType(data['expiry'], 'Integer');
      }
      if (data.hasOwnProperty('key')) {
        obj['key'] = ApiClient.convertToType(data['key'], 'String');
      }
      if (data.hasOwnProperty('legacyContentId')) {
        obj['legacyContentId'] = ApiClient.convertToType(data['legacyContentId'], 'String');
      }
      if (data.hasOwnProperty('legacyTransactionId')) {
        obj['legacyTransactionId'] = ApiClient.convertToType(data['legacyTransactionId'], 'String');
      }
      if (data.hasOwnProperty('message')) {
        obj['message'] = ApiClient.convertToType(data['message'], 'String');
      }
      if (data.hasOwnProperty('mimeType')) {
        obj['mimeType'] = ApiClient.convertToType(data['mimeType'], 'String');
      }
      if (data.hasOwnProperty('preview')) {
        obj['preview'] = ApiClient.convertToType(data['preview'], [PreviewData]);
      }
      if (data.hasOwnProperty('rawResource')) {
        obj['rawResource'] = BlobLocation.constructFromObject(data['rawResource']);
      }
      if (data.hasOwnProperty('resourceType')) {
        obj['resourceType'] = ApiClient.convertToType(data['resourceType'], 'String');
      }
      if (data.hasOwnProperty('states')) {
        obj['states'] = ApiClient.convertToType(data['states'], ['String']);
      }
      if (data.hasOwnProperty('status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'String');
      }
      if (data.hasOwnProperty('transactionDataType')) {
        obj['transactionDataType'] = ApiClient.convertToType(data['transactionDataType'], 'String');
      }
      if (data.hasOwnProperty('transactionType')) {
        obj['transactionType'] = ApiClient.convertToType(data['transactionType'], 'String');
      }
      if (data.hasOwnProperty('uniqueIdentifier')) {
        obj['uniqueIdentifier'] = ApiClient.convertToType(data['uniqueIdentifier'], 'String');
      }
    }
    return obj;
  }


  /**
   * @member {String} contentId
   */
  exports.prototype['contentId'] = undefined;

  /**
   * @member {Array.<String>} contentIdsToPrune
   */
  exports.prototype['contentIdsToPrune'] = undefined;

  /**
   * @member {Integer} created
   */
  exports.prototype['created'] = undefined;

  /**
   * @member {String} creatorId
   */
  exports.prototype['creatorId'] = undefined;

  /**
   * @member {Object} customData
   */
  exports.prototype['customData'] = undefined;

  /**
   * @member {Boolean} expired
   */
  exports.prototype['expired'] = undefined;

  /**
   * @member {Integer} expiry
   */
  exports.prototype['expiry'] = undefined;

  /**
   * @member {String} key
   */
  exports.prototype['key'] = undefined;

  /**
   * @member {String} legacyContentId
   */
  exports.prototype['legacyContentId'] = undefined;

  /**
   * @member {String} legacyTransactionId
   */
  exports.prototype['legacyTransactionId'] = undefined;

  /**
   * @member {String} message
   */
  exports.prototype['message'] = undefined;

  /**
   * @member {module:model/Transaction.MimeTypeEnum} mimeType
   */
  exports.prototype['mimeType'] = undefined;

  /**
   * @member {Array.<module:model/PreviewData>} preview
   */
  exports.prototype['preview'] = undefined;

  /**
   * This field is only for deserialization from the DB for backwards-compatibility\n\n DO NOT USE FOR ANY LOGIC
   * @member {module:model/BlobLocation} rawResource
   */
  exports.prototype['rawResource'] = undefined;

  /**
   * @member {module:model/Transaction.ResourceTypeEnum} resourceType
   */
  exports.prototype['resourceType'] = undefined;

  /**
   * @member {Array.<module:model/Transaction.StatesEnum>} states
   */
  exports.prototype['states'] = undefined;

  /**
   * @member {module:model/Transaction.StatusEnum} status
   */
  exports.prototype['status'] = undefined;

  /**
   * @member {module:model/Transaction.TransactionDataTypeEnum} transactionDataType
   */
  exports.prototype['transactionDataType'] = undefined;

  /**
   * @member {module:model/Transaction.TransactionTypeEnum} transactionType
   */
  exports.prototype['transactionType'] = undefined;

  /**
   * A field uniquely identifies a transaction record
   * @member {String} uniqueIdentifier
   */
  exports.prototype['uniqueIdentifier'] = undefined;


  /**
   * Allowed values for the <code>mimeType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.MimeTypeEnum = { 
    /**
     * value: UNDEFINED
     * @const
     */
    UNDEFINED: "UNDEFINED",
    
    /**
     * value: TEXT
     * @const
     */
    TEXT: "TEXT",
    
    /**
     * value: GIF
     * @const
     */
    GIF: "GIF",
    
    /**
     * value: JPEG
     * @const
     */
    JPEG: "JPEG",
    
    /**
     * value: PNG
     * @const
     */
    PNG: "PNG",
    
    /**
     * value: TIFF
     * @const
     */
    TIFF: "TIFF",
    
    /**
     * value: BMP
     * @const
     */
    BMP: "BMP",
    
    /**
     * value: ZIP
     * @const
     */
    ZIP: "ZIP",
    
    /**
     * value: NOTEBOOK
     * @const
     */
    NOTEBOOK: "NOTEBOOK",
    
    /**
     * value: NOTEBOOK_PAGE_SVG
     * @const
     */
    NOTEBOOK_PAGE_SVG: "NOTEBOOK_PAGE_SVG",
    
    /**
     * value: NOTEBOOK_PAGE_XML
     * @const
     */
    NOTEBOOK_PAGE_XML: "NOTEBOOK_PAGE_XML",
    
    /**
     * value: COMMON_CARTRIDGE
     * @const
     */
    COMMON_CARTRIDGE: "COMMON_CARTRIDGE",
    
    /**
     * value: SMART_CARTRIDGE
     * @const
     */
    SMART_CARTRIDGE: "SMART_CARTRIDGE",
    
    /**
     * value: PDF
     * @const
     */
    PDF: "PDF",
    
    /**
     * value: PPT
     * @const
     */
    PPT: "PPT",
    
    /**
     * value: PPTX
     * @const
     */
    PPTX: "PPTX",
    
    /**
     * value: JSON
     * @const
     */
    JSON: "JSON",
    
    /**
     * value: WORKSPACE
     * @const
     */
    WORKSPACE: "WORKSPACE",
    
    /**
     * value: LESSONS
     * @const
     */
    LESSONS: "LESSONS"
  };  /**
   * Allowed values for the <code>resourceType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ResourceTypeEnum = { 
    /**
     * value: IMAGE
     * @const
     */
    IMAGE: "IMAGE",
    
    /**
     * value: PDF
     * @const
     */
    PDF: "PDF",
    
    /**
     * value: POWERPOINT
     * @const
     */
    POWERPOINT: "POWERPOINT",
    
    /**
     * value: NOTEBOOK
     * @const
     */
    NOTEBOOK: "NOTEBOOK",
    
    /**
     * value: PAGE_SVG
     * @const
     */
    PAGE_SVG: "PAGE_SVG",
    
    /**
     * value: XML
     * @const
     */
    XML: "XML",
    
    /**
     * value: JSON
     * @const
     */
    JSON: "JSON",
    
    /**
     * value: GALLERY
     * @const
     */
    GALLERY: "GALLERY",
    
    /**
     * value: PUBLISHER
     * @const
     */
    PUBLISHER: "PUBLISHER",
    
    /**
     * value: TEXT
     * @const
     */
    TEXT: "TEXT",
    
    /**
     * value: ZIP
     * @const
     */
    ZIP: "ZIP",
    
    /**
     * value: CARTRIDGE
     * @const
     */
    CARTRIDGE: "CARTRIDGE",
    
    /**
     * value: AMP_WORKSPACE
     * @const
     */
    AMP_WORKSPACE: "AMP_WORKSPACE",
    
    /**
     * value: WORKSPACE
     * @const
     */
    WORKSPACE: "WORKSPACE",
    
    /**
     * value: LESSONS
     * @const
     */
    LESSONS: "LESSONS",
    
    /**
     * value: WORKSPACE_HOLDER
     * @const
     */
    WORKSPACE_HOLDER: "WORKSPACE_HOLDER",
    
    /**
     * value: WIDGET
     * @const
     */
    WIDGET: "WIDGET",
    
    /**
     * value: WIDGET_PACKAGE
     * @const
     */
    WIDGET_PACKAGE: "WIDGET_PACKAGE",
    
    /**
     * value: UNDEFINED
     * @const
     */
    UNDEFINED: "UNDEFINED"
  };
  /**
   * Allowed values for the <code>states</code> property.
   * @enum {String}
   * @readonly
   */
  exports.StatesEnum = { 
    /**
     * value: QUEUED
     * @const
     */
    QUEUED: "QUEUED",
    
    /**
     * value: LOADING
     * @const
     */
    LOADING: "LOADING",
    
    /**
     * value: READY
     * @const
     */
    READY: "READY",
    
    /**
     * value: PUBLISHED
     * @const
     */
    PUBLISHED: "PUBLISHED",
    
    /**
     * value: UNPUBLISHED
     * @const
     */
    UNPUBLISHED: "UNPUBLISHED",
    
    /**
     * value: DEADQUEUED
     * @const
     */
    DEADQUEUED: "DEADQUEUED"
  };  /**
   * Allowed values for the <code>status</code> property.
   * @enum {String}
   * @readonly
   */
  exports.StatusEnum = { 
    /**
     * value: PROCESSING
     * @const
     */
    PROCESSING: "PROCESSING",
    
    /**
     * value: FAILED
     * @const
     */
    FAILED: "FAILED",
    
    /**
     * value: CHILD_FAILED
     * @const
     */
    CHILD_FAILED: "CHILD_FAILED",
    
    /**
     * value: PROCESSED_BUT_CHILD_FAILED
     * @const
     */
    PROCESSED_BUT_CHILD_FAILED: "PROCESSED_BUT_CHILD_FAILED",
    
    /**
     * value: PROCESSED
     * @const
     */
    PROCESSED: "PROCESSED",
    
    /**
     * value: QUEUED
     * @const
     */
    QUEUED: "QUEUED"
  };  /**
   * Allowed values for the <code>transactionDataType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.TransactionDataTypeEnum = { 
    /**
     * value: SMEX
     * @const
     */
    SMEX: "SMEX",
    
    /**
     * value: OTHER
     * @const
     */
    OTHER: "OTHER"
  };  /**
   * Allowed values for the <code>transactionType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.TransactionTypeEnum = { 
    /**
     * value: NEW_UPLOAD
     * @const
     */
    NEW_UPLOAD: "NEW_UPLOAD",
    
    /**
     * value: EDIT
     * @const
     */
    EDIT: "EDIT",
    
    /**
     * value: REPROCESS_EXISTING_ID
     * @const
     */
    REPROCESS_EXISTING_ID: "REPROCESS_EXISTING_ID",
    
    /**
     * value: REPROCESS_NEW_ID
     * @const
     */
    REPROCESS_NEW_ID: "REPROCESS_NEW_ID",
    
    /**
     * value: REGENERATE_NOTEBOOK
     * @const
     */
    REGENERATE_NOTEBOOK: "REGENERATE_NOTEBOOK",
    
    /**
     * value: COPY
     * @const
     */
    COPY: "COPY",
    
    /**
     * value: PREVIEW_RENEW
     * @const
     */
    PREVIEW_RENEW: "PREVIEW_RENEW",
    
    /**
     * value: PREVIEW_RENEW_BK
     * @const
     */
    PREVIEW_RENEW_BK: "PREVIEW_RENEW_BK"
  };

  return exports;
}));
